import * as React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { default as DetallePedido } from '../../components/Pedidos/detallePedido'
import * as pedidoActions from '../../reducers/pedidosReducer/actions'
import * as tuerneroActions from '../../reducers/TurneroReducer/actions'
import { pedidoDetalleSelector,sugerenciasSelector,motivosEliminacionSelector} from '../../selectors/pedidosSelector'
import { instalacionSelector } from '../../selectors/sessionSelector'
import * as Notification from '../../components/Common/notification'
import {calendarioSelector} from '../../selectors/turneroSelector';
import { usuarioSelector, sucursalSelector } from '../../selectors/sessionSelector'
import { formatMoney } from '../../components/Common/decimalHelper'

const modalidad = {
  Pickup: 1,
  Delivery: 2
}

const formaPago = {
  PagaAlRetirar: 1,
  MercadoPago: 2,
  Mobbex: 3
}

class PedidoDetalleContainer extends React.Component {

  constructor(props) {
    super(props)

    // busco los datos iniciales
    let id = props.match.params.idPedido

    if (id) {
      props.sagaGetPedidoId(id)
    }
    else {
      this.props.history.goBack();
    }
    
    this.estados = {
      "Entregado": "Preparado",
      "Preparado": "Confirmado",
      "Confirmado": "Borrador",
      "Abandonado": "Borrador"
    }

    this.state = {
      id: id,
      openModalTotalPagar: false,
      totalAPagar: undefined,
      bolsasFrios:undefined,
      bolsasCongelados:undefined,
      canastos: undefined,
      observacionPicking: undefined,
      errorTotalAPagar: undefined,
      openModalInfoUsuario: false,      
      openModalDetalleFraude:false,
      openModalTurno: false,
      openModalMotivoEliminacion: false,
      openModalNoDisponible: false,
      botonOk: "",
      usuarioCargado: false,
      habilitarInputOtro: false,
      motivoOtro: undefined,
      motivoSeleccionado: undefined,
      errorMotivo: undefined,
      checkBoxNoMostrarModal: false,
      revertirNoDisponible: undefined,
      idPDNoDisponible: undefined,
      openBuscador: false,
      valueBusqueda: undefined,
      pedidoFiltrado: undefined,

      //georrefenciacion
      domicilioGeorreferenciacion: undefined,
      openModalGeorreferenciar: false,

      //turnos
      fechaSeleccionada: undefined,
      horaSeleccionada: undefined,
      modalidadSelected: undefined,
      showDireccion: false,

      // datos facturacion
      showDatosFacturacionModal: false,

      //expandir botones
      expandirBotones: false,

      handleOnPreparado: () => {
        if (this.props.pedido.pedidoDetalles.find(x => !x.listo))
          this.setState({
            openModalConfirm: true,
            botonOk: "Preparar",
            mensajeConfirmacion: `Falta listar artículos del pedidos. ¿Desea terminar?`,
            handleOk: () => {
              /*let total = this.props.pedido.totalAPagar ? this.props.pedido.totalAPagar : this.props.pedido.totalConfirmado*/
              this.setState({openModalTotalPagar: true/*, totalAPagar: total*/}); 
            }
          })
        else
          this.setState({openModalTotalPagar: true});
      }
      ,
      handleOnEntregado: () => {
        this.props.sagaEntregararPedido(id);
      }
      ,
      handleOnEliminar: () => {
        this.setState({
          openModalMotivoEliminacion: true
          /*openModalConfirm: true,
          botonOk: "Borrar",
          mensajeConfirmacion: `Está por borrar el pedido.`,
          handleOk: () => { this.props.sagaEliminarPedido(id); }*/
        })
      }
      ,
      handleOnRevertir: (estado) => {
        this.setState({
          openModalConfirm: true,
          botonOk: "Revertir",
          mensajeConfirmacion: `Está por volver el pedido al estado ${this.estados[this.props.pedido.estadoPedido.descripcion]}`,
          handleOk: () => { this.props.sagaRevertirPedido(id); }
        })
      }
      ,
      handleOnCloseConfirmacion: () => { 
        this.setState({ 
          openModalConfirm: false,
          motivoOtro: undefined,
          errorMotivo: undefined,
          motivoSeleccionado: undefined,
          habilitarInputOtro: false,
        }) 
      },
      handleOnVolver: () => { props.history.goBack() },
      modalVerPedido: false,
      
      itemVisto: {},
      modalVerPedidoOk: null,
      modalVerPedidoClose: () => { this.setState({ modalVerPedido: false }) },

      itemReemplazar: {},
      modalReemplazar:false,
      sugerenciasReemplazo:[],

      modalReemplazarClose: () => { this.setState({
        modalReemplazar: false,
        itemReemplazar: {},
        sugerenciasReemplazo:[]
       }) },
      
      
    }

    //busco la lista de motivos de eliminacion
    this.props.sagaGetMotivosEliminacion()

  }

  setExpandirBotones = (e) => {
    this.setState({
      expandirBotones: e
    })
  }

  componentDidUpdate = () => {
    if(this.state.usuarioCargado === false && this.props.usuario !== undefined){
        this.setState({usuarioCargado: true}, () => {
            if(this.props.usuario.idRol === 2){
                window.location.hash = '/Articulo'
            }
        })
    }
}

  componentWillReceiveProps(nextProps) {
    this.render()
  }

  marcarPedidoDetalleListo = (idPedidoDetalle, revertir) => {
    
    let payload = {
      id: idPedidoDetalle,
      revertir: revertir
    }

    payload.callback = (idPD, revertirPD) => {
      if(this.state.pedidoFiltrado !== undefined){
        let pedidoFiltrado = {...this.state.pedidoFiltrado}
        let item_index = pedidoFiltrado.pedidoDetalles.findIndex(x=> x.idDetallePedido === idPD);
        pedidoFiltrado.pedidoDetalles[item_index].listo = !revertirPD;

        this.setState({pedidoFiltrado: pedidoFiltrado})
      }
    } 

    this.props.sagaMarcarPedidoDetallerListo(payload)
  }

  marcarPedidoDetalleNoDisponible = (idPedidoDetalle, revertir) => {
    
    let payload = {
      id: idPedidoDetalle,
      revertir: revertir
    }

    this.props.sagaMarcarPedidoDetallerNoDisponible(payload)
    
  }

  getCookie = (cname) => {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  setCookie = (cname, cvalue, exdays) => {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  handleOnClickMarcarPedidoDetalleNoDisponible = (aceptar, idPedidoDetalle, revertir) => {
    
    let nameCookie = this.props.usuario.id
    if(revertir !== undefined ){
      nameCookie = nameCookie +  (revertir ? "Disponible" : "NoDisponible")
      this.setState({idPDNoDisponible: idPedidoDetalle, revertirNoDisponible: revertir})
    }
    else{
      nameCookie = nameCookie +  (this.state.revertirNoDisponible ? "Disponible" : "NoDisponible")
    }

    //busca cookie
    let existeCookie = this.getCookie(nameCookie)

    //abre modal
    if(this.state.openModalNoDisponible === false && !existeCookie){
      this.setState({checkBoxNoMostrarModal: false, openModalNoDisponible: true, idPDNoDisponible: idPedidoDetalle, revertirNoDisponible: revertir})
      return
    }

    //acción boton cancelar
    if(aceptar === false){
      this.setState({checkBoxNoMostrarModal: false, openModalNoDisponible: false, idPDNoDisponible: undefined, revertirNoDisponible: undefined})
      return
    }

    let payload = {
      id: idPedidoDetalle !== undefined ? idPedidoDetalle : this.state.idPDNoDisponible,
      revertir: revertir !== undefined ? revertir : this.state.revertirNoDisponible
    }


    payload.callback = (idPD, revertirPD) => {
      debugger
      if(this.state.pedidoFiltrado !== undefined){
        let pedidoFiltrado = {...this.state.pedidoFiltrado}
        let item_index = pedidoFiltrado.pedidoDetalles.findIndex(x=> x.idDetallePedido === idPD);
        pedidoFiltrado.pedidoDetalles[item_index].noDisponible = !revertirPD;

        this.setState({pedidoFiltrado: pedidoFiltrado})
      }
    }    
    
    /* existe cookie */
    if(existeCookie){
      //llamar api 
      this.setState({checkBoxNoMostrarModal: false, openModalNoDisponible: false, idPDNoDisponible: undefined, revertirNoDisponible: undefined}, () => {
        this.props.sagaMarcarPedidoDetallerNoDisponible(payload)
      })
    }
    else{
      /* no existe cookie */
      //crear cookie
      if(this.state.checkBoxNoMostrarModal){
        this.setCookie(nameCookie, true, 365)
      }

      //llamar api      
      this.setState({checkBoxNoMostrarModal: false, openModalNoDisponible: false, idPDNoDisponible: undefined, revertirNoDisponible: undefined}, () => {
        this.props.sagaMarcarPedidoDetallerNoDisponible(payload)
      })
    }
  }

  handleOnChangeCheckboxModal = (e) => {
    let value = e.target.checked

    this.setState({checkBoxNoMostrarModal: value})
  }
  
  obtenerSugerencias =(payload)=>{
    this.props.sagaBuscarSugerenciasReemplazo(payload);
  }

  handleOnClickGuardarReemplazo = (payload, callback, nuevoArticulo) => {
    
    payload.callback = () => {
      this.setState({
        modalReemplazar: false,
        itemReemplazar: {},
        sugerenciasReemplazo:[]
      }, () => { 
        callback() 
      })
    }

    if(nuevoArticulo){
      this.props.sagaSaveNevoPedidoDetalleReemplazo(payload)
    }
    else{
      this.props.sagaSaveNuevaCantidadPedidoDetalle(payload)
    }
  }

  handleOnQuitarPedidoDetalleReemplazo = (payload) => {
    let callbackPayload = payload.callback

    payload.callback = () => {
      callbackPayload()
    }

    this.props.sagaQuitarPedidoDetalleReemplazo(payload)
  }

  handleOnChangeTotalAPagar = (e) => {
    let value = undefined
    if (Number.isNaN(e.floatValue)) {
			value = e.value
		}
		else { 
      value = e.floatValue
    }

    this.setState({totalAPagar: value})
  } 

  handleOnChangeBolsasFrios = (e) => {
    this.setState({bolsasFrios: e.value})
  } 

  handleOnChangeBolsasCongelados = (e) => {
    this.setState({bolsasCongelados: e.value})
  } 

  handleOnChangeCanastos = (e) => {
    this.setState({canastos: e.value})
  }

  handleOnChangeObservacionPicking = (e) => {
    this.setState({[e.target.name]:e.target.value})
  }

  handleOnClickTotalAPagar = (flag) => {

    if (!flag) {
      this.setState({
        errorTotalAPagar: undefined, 
        openModalTotalPagar: false, 
        totalAPagar: undefined,
        bolsasFrios:undefined,
        bolsasCongelados: undefined,
        canastos: undefined,
        observacionPicking:undefined
      });
      return;
    }

    if (this.state.totalAPagar === undefined || this.state.totalAPagar === null || this.props.totalAPagar === "") {
      this.setState({errorTotalAPagar: "Ingrese un monto"})
      return
    }

    if (!(this.state.totalAPagar > 0)) {
      this.setState({errorTotalAPagar: "Ingrese un monto"})
      return
    }

    // Asignación del precio total del pedido
    let precioTotalOriginal = this.props.pedido.totalConfirmado;

    // Si el monto a cobrar es mayor, muestro advertencia al empleado
    if (this.state.totalAPagar > precioTotalOriginal) {
      const continuarProcesoPago = () => {
        this.procesarPagoNormal();
      };

      this.setState({
        mensajeConfirmacion: `Está por cobrar ${formatMoney(this.state.totalAPagar)}, un monto mayor al original de ${formatMoney(precioTotalOriginal)}. ¿Desea continuar?`,
        openModalConfirm: true,
        botonOk: "Continuar",
        handleOk: continuarProcesoPago,
      });
      return;
    }

    // Si no requiere confirmación, proceso el pago directamente
    this.procesarPagoNormal();
  }

  procesarPagoNormal = () => {
    if(this.props.pedido.idFormaPagoOnline === 1){
      let payload = {
        totalAPagar: this.state.totalAPagar,
        bolsasFrios:this.state.bolsasFrios,
        bolsasCongelados:this.state.bolsasCongelados,
        canastos: this.state.canastos,
        observacionPicking: this.state.observacionPicking,
        idPedido: this.props.pedido.idPedido,
        idFormaPago: this.props.pedido.idFormaPagoOnline,
        idInstalacion: this.props.instalacion.id
      }
      payload.callback = () => {
        this.setState({
          openModalTotalPagar: false, 
          totalAPagar: undefined, 
          bolsasFrios:undefined,
          bolsasCongelados:undefined,
          canastos: undefined,
          observacionPicking: undefined
        }, () => {
          this.props.sagaPrepararPedido(this.props.pedido.idPedido);
        })
      }
      this.props.sagaSetTotalAPagar(payload)
    }
    else{
      if(this.props.pedido.envioDomicilio !== undefined && this.props.pedido.envioDomicilio !== null){
        let value = this.props.pedido.totalConfirmado + this.props.pedido.envioDomicilio
  
        if(this.props.pedido.idFormaPagoOnline === formaPago.Mobbex && this.props.pedido.pagado === false && this.state.totalAPagar > (value * this.props.pedido.margenMobbex)){
          let porcentaje = ((this.props.pedido.margenMobbex * 100) - 100).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
          this.setState({errorTotalAPagar: "El monto no puede ser mayor a $ " + value + " + el " + porcentaje + "%"})
          return
        }
        if((this.props.pedido.idFormaPagoOnline === formaPago.MercadoPago || 
          this.props.pedido.idFormaPagoOnline === formaPago.Mobbex && this.props.pedido.pagado === true) && 
          this.state.totalAPagar > (value)){
          this.setState({errorTotalAPagar: "El monto no puede ser mayor a $ " + value})
          return
        }
      }
      else{
        if(this.props.pedido.idFormaPagoOnline === formaPago.Mobbex && this.props.pedido.pagado === false && this.state.totalAPagar > (this.props.pedido.totalConfirmado * this.props.pedido.margenMobbex)){
          let porcentaje = ((this.props.pedido.margenMobbex * 100) - 100).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
          this.setState({errorTotalAPagar: "El monto no puede ser mayor a $ " + this.props.pedido.totalConfirmado + " + el " + porcentaje + "%"})
          return
        }
        if((this.props.pedido.idFormaPagoOnline === formaPago.MercadoPago || 
          this.props.pedido.idFormaPagoOnline === formaPago.Mobbex && this.props.pedido.pagado === true) && 
          this.state.totalAPagar > this.props.pedido.totalConfirmado){
          this.setState({errorTotalAPagar: "El monto no puede ser mayor a $ " + this.props.pedido.totalConfirmado})
          return
        }
      }
      
      let payload = {
        totalAPagar: this.state.totalAPagar,
        bolsasFrios:this.state.bolsasFrios,
        bolsasCongelados:this.state.bolsasCongelados,
        canastos: this.state.canastos,
        observacionPicking: this.state.observacionPicking,
        idPedido: this.props.pedido.idPedido,
        idFormaPago: this.props.pedido.idFormaPagoOnline,
        idInstalacion: this.props.instalacion.id
      }
  
      payload.callback = () => {
        this.setState({
          openModalTotalPagar: false, 
          totalAPagar: undefined, 
          bolsasFrios:undefined,
          bolsasCongelados:undefined,
          canastos: undefined,
          observacionPicking: undefined
        }, () => {
          this.props.sagaPrepararPedido(this.props.pedido.idPedido);
        })
      }
  
      this.props.sagaSetTotalAPagar(payload)
    }
  }

  handleOnClickBtnInfo = () => {
    let value = !this.state.openModalInfoUsuario
    this.setState({openModalInfoUsuario: value})
  }

  handleOnClickBtnDetalleFraude = () => {
    let value = !this.state.openModalDetalleFraude
    this.setState({openModalDetalleFraude: value})
  }

  handleOnClickTurno = (event, modalidadSelected) => {
    
    let payload = {}
    if(modalidadSelected === undefined){
      payload.idTipoCalendario = this.props.pedido && this.props.pedido.turno ? this.props.pedido.turno.idTipoCalendario : undefined
    }
    else{
      payload.idTipoCalendario = modalidadSelected
    }
    console.log({props: this.props, state: this.state})
    payload.idInstalacion = this.props.sucursal ? this.props.sucursal.idSucursal : undefined
    payload.idRecurso = 1

    payload.callBack = () => {
      this.setState({openModalTurno: true})
    }

    this.setState({modalidadSelected: payload.idTipoCalendario}, () => {
      //busco el calendario 
      this.props.sagaFetchCalendario(payload)
    })    
  }
  handleOnClickCerrarTurnos = () => {
    this.setState({
      openModalTurno: false,
      fechaSeleccionada: undefined,
      horaSeleccionada: undefined,
      modalidadSelected: undefined,
      showDireccion: false,
    })
  }

  handleOnClickDia = (itemDia) => {
    this.setState({fechaSeleccionada: itemDia})
  }

  handleOnClickHorario = (itemHorario) => {
    let showDireccion = this.state.showDireccion
    let payload = undefined

    if(this.state.modalidadSelected === modalidad.Pickup){
      payload = {}
      payload.idFormaEntrega = this.state.modalidadSelected
      payload.idCalendarioHorario = itemHorario.idHorario
      payload.fechaTurno = this.state.fechaSeleccionada.fecha      
      payload.idPedido = this.props.pedido.idPedido

      payload.callback = () => {
        Notification.showSuccess(`Turno cambiado con éxito`)
        
        this.setState({
          horaSeleccionada: undefined,
          fechaSeleccionada: undefined,
          openModalTurno: false
        })
      }

      payload.callbackError = () => {
        this.setState({
          horaSeleccionada: undefined,
          fechaSeleccionada: undefined,
          openModalTurno: false,
          showDireccion: false
        })
      }
    }
    else{
      showDireccion = true
    }

    this.setState({horaSeleccionada: itemHorario, showDireccion: showDireccion}, () => {   
      if(payload){
        this.props.sagaChangeTurno(payload)
      }
    })
  }

  handleOnShowTurnero = () => {
    this.setState({showDireccion: false})
  }

  handleOnClickGeorreferenciar = () => {
    let value = !this.state.openModalGeorreferenciar

    let domicilioGeorreferenciacion = undefined

    if(value && this.props.pedido.listaDomicilios && this.props.pedido.listaDomicilios.length > 0){
      let idDomicilioEntrega = this.props.pedido.idDomicilioEntrega

      this.props.pedido.listaDomicilios.forEach(d => {
        if(d.idDomicilioEntrega === idDomicilioEntrega){
          domicilioGeorreferenciacion = d
        }
      });
    }

    this.setState({openModalGeorreferenciar: value, domicilioGeorreferenciacion: domicilioGeorreferenciacion})
  }

  handleChangeRadioButtonDomicilio = (event) => {
    
    let select = event
    let item = undefined

    if(this.props.pedido === undefined || this.props.pedido.listaDomicilios === undefined || 
      this.props.pedido.listaDomicilios.length === 0){
      return
    }

    this.props.pedido.listaDomicilios.forEach(d => {
      if(d.idDomicilioEntrega.toString() === select){
        item = d
      }
    });
    
    let payload = {}
    payload.idFormaEntrega = this.state.modalidadSelected
    payload.idCalendarioHorario = this.state.horaSeleccionada.idHorario
    payload.fechaTurno = this.state.fechaSeleccionada.fecha
    payload.idPedido = this.props.pedido.idPedido
    payload.domicilio = item.domicilio
    payload.idDomicilioEntrega = item.idDomicilioEntrega

    payload.callback = () => {
      //notificacion
      Notification.showSuccess(`Turno cambiado con éxito`)

      this.setState({
        horaSeleccionada: undefined,
        fechaSeleccionada: undefined,
        openModalTurno: false,
        showDireccion: false
      })
    }

    payload.callbackError = () => {
      this.setState({
        horaSeleccionada: undefined,
        fechaSeleccionada: undefined,
        openModalTurno: false,
        showDireccion: false
      })
    }

    this.props.sagaChangeTurno(payload)
  }

  handleAfterSaveNuevoDomicilio = (idDomicilio) => {
    
    if(this.props.pedido === undefined || this.props.pedido.listaDomicilios === undefined || 
      this.props.pedido.listaDomicilios.length === 0){
      return
    }

    let item = undefined

    this.props.pedido.listaDomicilios.forEach(de => {
      if(de.idDomicilioEntrega === idDomicilio){
        item = de
      }
    });

    let payload = {}
    payload.idFormaEntrega = this.state.modalidadSelected
    payload.idCalendarioHorario = this.state.horaSeleccionada.idHorario
    payload.fechaTurno = this.state.fechaSeleccionada.fecha
    payload.idPedido = this.props.pedido.idPedido
    payload.domicilio = item.domicilio
    payload.idDomicilioEntrega = item.idDomicilioEntrega

    payload.callback = () => {
      //notificacion
      Notification.showSuccess(`Turno cambiado con éxito`)

      this.setState({
        horaSeleccionada: undefined,
        fechaSeleccionada: undefined,
        openModalTurno: false,
        showDireccion: false
      })
    }

    payload.callbackError = () => {
      this.setState({
        horaSeleccionada: undefined,
        fechaSeleccionada: undefined,
        openModalTurno: false,
        showDireccion: false
      })
    }

    this.props.sagaChangeTurno(payload)
  }

  handleOnSaveGeorreferenciacion = (payload) => {
    
    if(this.state.domicilioGeorreferenciacion !== undefined){
      payload.idDomicilioEntrega = this.state.domicilioGeorreferenciacion.idDomicilioEntrega
    }

    payload.idPedido = this.props.pedido.idPedido

    payload.callback = () => {
      //notificacion
      Notification.showSuccess(`Actualización de domicilio exitosa`)

      this.setState({
        openModalGeorreferenciar: undefined,
        domicilioGeorreferenciacion: undefined,
      })
    }

    payload.callbackError = () => {
      this.setState({
        openModalGeorreferenciar: undefined,
        domicilioGeorreferenciacion: undefined,
      })
    }

    this.props.sagaGeorreferenciacionDomicilio(payload)
  }

  handleChangeRadioButtonMotivo = (e, item) => {
    
    let value = e.target.value
    let habilitarInputOtro = false

    if(item.descripcion === "Otro"){
      habilitarInputOtro = true
    }

    this.setState({
      motivoSeleccionado: value,
      habilitarInputOtro: habilitarInputOtro,
      motivoOtro: undefined,
      errorMotivo: undefined
    })
  }

  handleOnChangeInputMotivo = (e) => {
    let value = e.target.value

    if(value && value.length <= 255){
      this.setState({
        motivoOtro: value
      })
    }
  }

  handleOnClickMotivoEliminar = (cancelar) => {
    //cierro el modal y limpio
    if(cancelar){
      this.setState({
        openModalMotivoEliminacion: false,
        motivoOtro: undefined,
        motivoSeleccionado: undefined,
        errorMotivo: undefined,
        habilitarInputOtro: false,
      })
    }
    else{
      //si presionó eliminar
      if(this.state.motivoSeleccionado !== undefined){
        //si seleccionó algo, valido si es "Otro"
        let motivo = undefined
        this.props.motivosEliminacion.forEach(me => {
          if(me.idMotivoEliminacion.toString() === this.state.motivoSeleccionado){
            motivo = me
          }
        });

        if(motivo.descripcion === "Otro" && (this.state.motivoOtro === undefined || this.state.motivoOtro === "" || this.state.motivoOtro === null)){
          this.setState({
            errorMotivo: "Complete el campo para continuar"
          })
          return
        }

        this.setState({
          openModalMotivoEliminacion: false,
          openModalConfirm: true,
          botonOk: "Borrar",
          mensajeConfirmacion: `Estás por eliminar un pedido en estado 'Preparado'. Debes reponer la mercadería en el inventario.`,
          handleOk: () => { this.eliminarPedido(this.state.id)}
        })
      }
      else{
        this.setState({
          errorMotivo: "Debe seleccionar un motivo"
        })
        return
      }
    }
  }

  eliminarPedido = (id) => {

    let payload = {}
    payload.idPedido = id
    payload.idMotivoEliminacion = parseInt(this.state.motivoSeleccionado)
    payload.otroMotivoEliminacion = this.state.motivoOtro
    payload.callback = () => {
      this.setState({
        openModalMotivoEliminacion: false,
        openModalConfirm: false,
        motivoOtro: undefined,
        motivoSeleccionado: undefined,
        errorMotivo: undefined,
        habilitarInputOtro: false,
      })
    }

    //
    this.props.sagaEliminarPedido(payload)
  }

  handleOnClickBtnSearch = () => {
    let value = this.state.openBuscador
    
    if(value){
      if(this.state.valueBusqueda !== undefined && this.state.valueBusqueda !== ""){
        //realizar busqueda
        let codigos = this.state.valueBusqueda.split(',')

        let pedidoFiltrado = {...this.props.pedido}

        pedidoFiltrado.pedidoDetalles = []
        pedidoFiltrado.rubros = []

        this.props.pedido.pedidoDetalles.forEach(pd => {
          if(this.estaIncluido(pd.codigoBarra, codigos) || this.estaIncluido(pd.codigoArticulo, codigos)){
            pedidoFiltrado.pedidoDetalles.push(pd)

            //armo rubros de pd filtrados
            let rubro = pedidoFiltrado.rubros.find(x => x.rubro === pd.rubro);
            let indexRubro = pedidoFiltrado.rubros.indexOf(rubro);
            if(rubro){
              if(!rubro.sub.includes(pd.subrubro)){
                pedidoFiltrado.rubros[indexRubro].sub.push(pd.subrubro)
              }
            }
            else{
              pedidoFiltrado.rubros.push({rubro: pd.rubro, sub: [pd.subrubro]})
            }
          }
        });

        this.setState({pedidoFiltrado: pedidoFiltrado})
      }
    }
    else{
      this.setState({openBuscador: !value})
    }
  }

  estaIncluido = (codigo, filtros) => {
    if(filtros === undefined || filtros.length === 0 || codigo === null || codigo === undefined){
      return false
    }

    let filtrado = filtros.filter(x => codigo === x.trim()) 
    
    return filtrado.length > 0 ? true : false
  }

  handleOnChangeFilter = (e) => {
    let value = e.target.value

    this.setState({valueBusqueda: value})
  }

  handleOnClearBusqueda = () => {
    this.setState({valueBusqueda: undefined, openBuscador: false, pedidoFiltrado: undefined})
  }

  render() {
    let pedido = this.props.pedido;

    let sugerenciasReemplazo = this.props.sugerencias;

    const { instalacion } = this.props;
    
    if (this.props.pedido && this.props.pedido.pedidoDetalles.map) {
      pedido.pedidoDetalles = this.props.pedido.pedidoDetalles.map(p => 
        ({
        ...p,
        permiteReemplazar : this.props.permisoReemplazo && !this.props.reemplazado && this.props.idPedidoDetalleReemplazado === null,
        estaReemplazado : this.props.permisoReemplazo && this.props.reemplazado && this.props.idPedidoDetalleReemplazado === null,
        esReemplazo : this.props.idPedidoDetalleReemplazado !==null,
        btnListo: !this.esReemplazo,
        btnReemplazar: this.props.permisoReemplazo && this.props.idPedidoDetalleReemplazado === null,
        btnNoDisponible:!this.esReemplazo && !this.estaReemplazado,
        btnQuitar:this.esReemplazo,

        onReemplazarClick: ()=>{ this.setState({
          modalReemplazar:true,
          itemReemplazar:p, 
                   
        })},
        
        onClick: () => {
          this.setState({
            modalVerPedido: true,
            itemVisto: p,
            modalVerPedidoOk: () => { this.props.sagaPrepararItemPedido(p.idDetallePedido, p.listo, () => { this.props.sagaGetPedidoId(this.state.id) }) },
          })
        }
        })
      );
    }
    return this.props.pedido && <DetallePedido 
                                  {...this.state}
                                  calendario={this.props.calendario ? this.props.calendario.calendario : undefined}
                                  handleOnQuitarPedidoDetalleReemplazo={this.handleOnQuitarPedidoDetalleReemplazo}
                                  handleOnClickGuardarReemplazo={this.handleOnClickGuardarReemplazo}
                                  handleOnClickTotalAPagar={this.handleOnClickTotalAPagar}
                                  handleOnChangeTotalAPagar={this.handleOnChangeTotalAPagar}
                                  handleOnChangeBolsasFrios={this.handleOnChangeBolsasFrios}
                                  handleOnChangeBolsasCongelados={this.handleOnChangeBolsasCongelados}
                                  handleOnChangeCanastos={this.handleOnChangeCanastos}
                                  handleOnChangeObservacionPicking={this.handleOnChangeObservacionPicking}
                                  handleOnClickBtnInfo={this.handleOnClickBtnInfo}
                                  handleOnClickBtnDetalleFraude={this.handleOnClickBtnDetalleFraude}
                                  
                                  handleOnClickGeorreferenciar={this.handleOnClickGeorreferenciar}
                                  handleOnSaveGeorreferenciacion={this.handleOnSaveGeorreferenciacion}
                                  handleAfterGeorreferenciacion={this.handleAfterGeorreferenciacion}
                                  handleOnClickTurno={this.handleOnClickTurno}
                                  handleOnClickDia={this.handleOnClickDia}
                                  handleOnClickHorario={this.handleOnClickHorario}
                                  handleOnClickCerrarTurnos={this.handleOnClickCerrarTurnos}
                                  handleOnShowTurnero={this.handleOnShowTurnero}
                                  handleChangeRadioButtonDomicilio={this.handleChangeRadioButtonDomicilio}
                                  handleAfterSaveNuevoDomicilio={this.handleAfterSaveNuevoDomicilio}
                                  instalacion={this.props.instalacion}

                                  handleOnClickBtnSearch={this.handleOnClickBtnSearch}
                                  handleOnChangeFilter={this.handleOnChangeFilter}
                                  handleOnClearBusqueda={this.handleOnClearBusqueda}

                                  motivosEliminacion={this.props.motivosEliminacion}
                                  handleChangeRadioButtonMotivo={this.handleChangeRadioButtonMotivo}
                                  handleOnChangeInputMotivo={this.handleOnChangeInputMotivo}
                                  handleOnClickMotivoEliminar={this.handleOnClickMotivoEliminar}
                                  obtenerSugerencias={this.obtenerSugerencias} 
                                  marcarPedidoDetalleNoDisponible={this.marcarPedidoDetalleNoDisponible} 
                                  handleOnClickMarcarPedidoDetalleNoDisponible={this.handleOnClickMarcarPedidoDetalleNoDisponible}
                                  handleOnChangeCheckboxModal={this.handleOnChangeCheckboxModal}
                                  marcarPedidoDetalleListo={this.marcarPedidoDetalleListo} 
                                  caratula={() => { this.props.sagaCaratulaPedido(this.state.id) }} 
                                  remito={() => { this.props.sagaRemitoPedido(this.state.id) }} 
                                  pedido={pedido}
                                  sucursal={this.props.sucursal}

                                  pickupText={instalacion.textoGenericoPickup || 'Pick-up'}
 
                                  visualizacion={this.props.sucursal && (pedido.idSucursal === this.props.sucursal.idSucursal || !pedido.idSucursal)}
                                  pedidoFiltrado={this.state.pedidoFiltrado}
                                  sugerenciasReemplazo={sugerenciasReemplazo !== undefined? sugerenciasReemplazo:[]}
                                  showDatosFacturacionModal={this.state.showDatosFacturacionModal}
                                  handleShowDatosFacturacionModal={(show) => this.setState({ showDatosFacturacionModal: show  })}
                                  envioBonificado={this.props.pedido.envioBonificado}
                                  montoEnvioBonificado={this.props.pedido.montoEnvioBonificado}
                                  setExpandirBotones={(newEdit) => {
                                    this.setExpandirBotones(newEdit);
                                  }}
                                  descripcionMotivo={this.props.pedido.idMotivoEliminacion? this.props.motivosEliminacion[this.props.pedido.idMotivoEliminacion - 1].descripcion: null}
                                /> || <div></div>
  }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ...pedidoActions,
    ...tuerneroActions
  }, dispatch)
}

function mapStateToProps(state) {
  return {
    pedido: pedidoDetalleSelector(state),
    sugerencias: sugerenciasSelector(state),
    instalacion: instalacionSelector(state),
    usuario: usuarioSelector(state),
    sucursal: sucursalSelector(state),
    calendario: calendarioSelector(state),
    motivosEliminacion: motivosEliminacionSelector(state)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PedidoDetalleContainer)
